import {TimeSpan} from "@sparkware/app-utils";
import {makeObservable, observable, runInAction} from "mobx";
import {namedSetInterval} from "../../../../common/utils/time-functions";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IJackpotBetsInfoModel} from "../models/jackpot-bets-info.model.interfeace";
import {IJackpotBetsStrategy} from "./jackpot-bets-strategy.interface";
import {JackpotBetsController_GetBrandJackpotsResponse} from "../../api/api.service";
import {JackpotBetsInfoModel} from "../models/jackpot-bets-info.model";

export class AnonymousJackpotBetsStrategy implements IJackpotBetsStrategy {
    constructor(private readonly services: IServiceFactoryExtended, initialJackpotBetsInfo: IJackpotBetsInfoModel | null) {
        makeObservable(this);
        this.jackpotBetsInfo = initialJackpotBetsInfo;
        this._updateFeedCache().finally(() => {
            this._startJackpotsBetsUpdatesLoop();
        });
    }

    @observable.ref
    jackpotBetsInfo: IJackpotBetsInfoModel | null = null;

    private _feedsRefreshIntervalRef: any = null;

    private get refreshInterval(): TimeSpan {
        try {
            const interval = this.services.configuration.servicesConfigs.JackpotBets?.feedsRefreshInterval ?? "00:00:20";
            return TimeSpan.parse(interval);
        } catch (err) {
            this.services.logger.error('Failed to parse jackpot refresh interval', err);
            return TimeSpan.fromSeconds(20);
        }

    }

    dispose(): void {
        if(this._feedsRefreshIntervalRef) {
            clearInterval(this._feedsRefreshIntervalRef);
        }
    }

    private _startJackpotsBetsUpdatesLoop(): void {
        this._feedsRefreshIntervalRef = namedSetInterval('JACKPOT_BETS_REFRESH_INTERVAL', async () => {
            await this._updateFeedCache();
        }, this.refreshInterval.totalMilliseconds);
    }

    private async _updateFeedCache(): Promise<void> {
        try {
            let response = await this._fetchFeedsFromServer();
            if(this.jackpotBetsInfo) {
                this.jackpotBetsInfo.updateRawInfo(response);
            } else {
                runInAction(() => {
                    this.jackpotBetsInfo = new JackpotBetsInfoModel(response, this.services) ;
                });
            }

        } catch (err) {
            this.services.logger.error('Failed to fetch jackpot bets feeds', err);
        }

    }

    private async _fetchFeedsFromServer(): Promise<JackpotBetsController_GetBrandJackpotsResponse> {
        const requestBody = {
            currencyCode: this.services.currency.currencyIso3,
            brandId: this.services.sdk.getBrandID(),
        };

        return await this.services.api.jackpotBetsController.getBrandJackpots(requestBody);
    }

}